<template>
  <div class="page-listings">

    <cashmanagement-tour v-if="$store.state.tour & !loading" />


    <!--
     <section
      v-if="loading || !invoices"
      class="pt-5 pb-4 pixelsbg bs-shadow mobile-top"
      style="min-height: 214px"
    >
      <div class="container">
        <h1 class="text-white mb0 lh1">Loading Cash Management....</h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </section>
    -->
   

    <section class="pt-5 pb-4 pixelsbggrid bs-shadow mobile-top">
      <div class="container">

        <div class="input-wrap">
        <input
          id="cash-step-1"
          class="top-search mt0"
          type="text"
          placeholder="Search Cash Management by AC Name..."
          v-model="searchValue"
          @keyup.enter.prevent="searchQuery"
          style="padding: 15px;"
        />
        <button
            :class="[showButton ? 'clear-btn' : 'clear-hide']"
            @click="clearSearch"
            type="button"
            class="d-flex align-items-center pr-3 clear-btn"
          >
            <svg
              class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              ></path>
            </svg>
          </button>
        </div>


        <div class="search-btns">
          <div class="left-side" style="max-width: 300px; width: 288px;">
            <div id="cash-step-2" class="ac-select">
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                v-model="acFilter"
              >
                <option :value="null" selected class="all-contractors">
                  Area Contractor
                </option>
                <option v-for="ac in acs" :key="ac.acid" :value="ac.acid">
                  {{ " " + toUpperCase(ac.acName) + " (" + ac.acid + ")" }}
                </option>
                <!--
				>{{ " " + ac.acName + " (" + ac.acid + ")" }}</option>
                -->
              </select>
            </div>
          </div>

          <div class="right-side">
            <button
              v-if="searchValue || acFilter"
              @click.prevent="searchQuery"
              class="search"
            >
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <button v-else class="search" disabled>
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <!--
            <button
              v-if="searchValue || acFilter || searching"
              @click="clearSearch"
              class="clear"
            >
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            <button v-else disabled class="clear">
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            -->
          </div>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="row">
        <div
          v-if="loading == true"
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div class="flex-box-wrap">
            <div class="flex-internal">
              <atom-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#575757'"
              />
              <p>Loading......</p>
            </div>
          </div>
        </div>

        <div
          v-else-if="loading == false && !filteredInvoices.length"
          class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
        >
          <div class="sorry-box">
            <img src="@/assets/img/sad.svg" />
            <h3>Sorry, no invoice was found...</h3>
            <button class="btn-primary" @click="firstLoad">
              Show me some Invoices
            </button>
          </div>
        </div>

        <div v-else class="col-xs-12 col-sm-12 col-12 col-lg-12">
          <listings-pagination :currPage="currPage" :totalPage="totalPage" :filteredListings="filteredInvoices" :setPage="setPage"/>


          <div>
            <div class="listing">
              <!--
          <div v-for="invoice in invoices" :key="invoice.Tid">
              -->
              <h2 class data-config-id="header">AC Aging Report</h2>
              <div class="rfr table-responsive">
               <table class="table-striped table-bordered">
  <thead>
    <tr>
      <th
        v-for="c in agingColumns"
        :key="c.key"
        scope="col"
        class="table-link"
        :class="[c.cls, { 'column-active': columnSort === c.key }]"
        @click="sortCol(c.key)"
      >
        <span class="th-inner">
          <span>{{ c.label }}</span>
          <i class="material-icons carrot-icon" :class="{ 'carrot-icon-active': columnSort === c.key }">filter_list</i>
        </span>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr
      v-for="(invoice, index) in filteredInvoices.slice(pageStart, pageStart + countOfPage)"
      :key="invoice.acid"
    >
      <td class="ac">
        <router-link
          v-if="invoice.total != 0"
          :to="'/cash-management/' + invoice.acid"
          :id="index === 0 ? 'cash-step-4' : ''"
        >
          {{ invoice.acName }}<span class="acid">({{ invoice.acid }})</span>
        </router-link>
        <span v-else>{{ invoice.acName }}<span class="acid">({{ invoice.acid }})</span></span>
      </td>
      <td class="num" :class="{ zero: !Number(invoice.bucket1) }">{{ formatPrice(invoice.bucket1) }}</td>
      <td class="num" :class="{ zero: !Number(invoice.bucket2) }">{{ formatPrice(invoice.bucket2) }}</td>
      <td class="num" :class="{ zero: !Number(invoice.bucket3) }">{{ formatPrice(invoice.bucket3) }}</td>
      <td class="num oldest" :class="{ zero: !Number(invoice.bucket4) }">{{ formatPrice(invoice.bucket4) }}</td>
      <td class="num total" :class="{ zero: !Number(invoice.total) }">{{ formatPrice(invoice.total) }}</td>
    </tr>
  </tbody>

  <tfoot>
    <tr>
      <td>Total ({{ filteredInvoices.length }} ACs)</td>
      <td class="num">{{ formatPrice(agingTotals.bucket1) }}</td>
      <td class="num">{{ formatPrice(agingTotals.bucket2) }}</td>
      <td class="num">{{ formatPrice(agingTotals.bucket3) }}</td>
      <td class="num">{{ formatPrice(agingTotals.bucket4) }}</td>
      <td class="num">{{ formatPrice(agingTotals.total) }}</td>
    </tr>
  </tfoot>
</table>
              </div>
              <!-- card -->
            </div>
          </div>

          <listings-pagination :currPage="currPage" :totalPage="totalPage" :filteredListings="filteredInvoices" :setPage="setPage"/>

        </div>
        <!-- end other column -->
      </div>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import cashmanagementTour from "../components/Tours/cashmanagementTour.vue";
import { formatCurrency } from '../utils/utils';
import ListingsPagination from '@/components/Pagination/ListingsPagination.vue';

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
  },
};

export default {
  name: "CashManagement",
  components: {
    AtomSpinner,
    ListingsPagination,
    cashmanagementTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      backend: import.meta.env.VITE_APP_SERVER_URL,
      searchValue: "",
      search: "",
      storedListings: [],
      searchRender: false,
      searchStarted: false,
      acs: [],
      invoices: [],
      selectedCat: "Show All",
      acFilter: "",
      searching: false,
      loading: false,
      countOfPage: 200,
      currPage: 1,
      noRGAFound: false,
      forumCats: [
        { id: 0, name: "Show All" },
        { id: 1, name: "Configura" },
        { id: 2, name: "Marketing" },
        { id: 3, name: "Other" },
        { id: 4, name: "Process" },
        { id: 5, name: "Product" },
        { id: 6, name: "Spacenet" },
      ],
      colSort: false,
      columnSort: "",
      agingColumns: [
        { key: "acName",  label: "AC Name", cls: "forty" },
        { key: "bucket1", label: "0–30",    cls: "ten num" },
        { key: "bucket2", label: "31–45",   cls: "ten num" },
        { key: "bucket3", label: "46–70",   cls: "ten num" },
        { key: "bucket4", label: "71+",     cls: "ten num" },
        { key: "total",   label: "Total",   cls: "twenty num" },
      ],
    };
  },
  methods: {
    firstLoad: function () {
      this.acFilter = null;
      this.searchStarted = false;
      this.$store.commit("setActivePage", "order-manage");
      this.acListSync();
      this.cashSync();
    },
    formatPrice(amount) {
      return formatCurrency(amount);
    },
    cashSync: function () {
      if (!this.$store.state.cashManagement.cashManageList.length) {
        this.loading = true;
        //console.log("getting eos from component");
        return axios
          .get(`${this.ordermanageapi}/cashmanagement/`, auth)
          .then((response) => {
            let sorted = response.data.aging.sort((a, b) =>
              a.acName > b.acName ? 1 : -1
            );
            this.invoices = sorted;
            this.loading = false;
            this.$store.commit("UPDATE_CASH", this.invoices);
          },(error) => {
            console.log(error);
            localStorage.removeItem("SSCUSER");
            this.$router.push("/");
          });
      } else {
        //console.log("vuex has length");
        this.invoices = this.$store.state.cashManagement.cashManageList;
        this.loading = false;
      }
    },

    acListSync: function () {
      if (!this.$store.state.acList.acList.length) {
        return axios
          .get(`${this.ordermanageapi}/aclist?active=true`, auth)
          .then((response) => {
            //console.log(response);
            const data = response.data;
            /*

            const low = data.filter(function (e) {
              return e.acid < 210;
            });

            const mid = data.filter(function (e) {
              return e.acid == 80069;
            });

            const high = data.filter(function (e) {
              return e.acid > 800000 && e.acid < 800250;
            });

            const all = low.concat(high).concat(mid);
            const alph = all.sort((a, b) => (a.acName > b.acName ? 1 : -1));

            this.acs = alph;
            */
            const alph = data.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            this.acs = alph;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });
      } else {
        this.acs = this.$store.state.acList.acList;
      }
    },

    toUpperCase: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.toUpperCase();
      });
    },

    searchReset: function () {
      this.selectedCat = "Show All";
    },

    setPage: function (idx) {
      this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },

    catSwitcher: function (catType) {
      //console.log(catType);
      let category = catType;
      console.log(category);
      if (category !== "Show All") {
        this.selectedCat = category;
        this.search = "";
        //console.log(category);
      } else {
        this.selectedCat = "Show All";
      }
    },

    searchQuery(event) {
      this.searchStarted = true;
      if (this.searchStarted === true) {
        this.storedListings = this.invoices;
      }

      this.search = "";
      this.loading = true;
      this.searching = true;

      return axios.get(this.searchEndpointCompute, auth).then((response) => {
        this.invoices = response.data.aging;
        this.searchValue = "";
        this.acFilter = null;
        this.loading = false;
      });
    },

    clearSearch() {
      if (this.searchStarted == true) {
        this.invoices = this.storedListings;
        this.searchStarted = false;
        this.searchRender = !this.searchRender;
      }

      //this.listings = this.storedListings;

      this.searchValue = "";
      this.searching = false;
      this.acFilter = null;
      this.$forceUpdate();

      //this.$forceUpdate();
      //Vue.set(this.listings, this.storedListings);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    sortCol: function (type) {
      this.columnSort = type;
      const COLUMN = type;
      console.log(COLUMN);
      if (this.colSort) {
        this.invoices.sort((a, b) => (a[COLUMN] > b[COLUMN] ? 1 : -1));
      } else {
        this.invoices.sort((a, b) => (a[COLUMN] < b[COLUMN] ? 1 : -1));
      }
      this.colSort = !this.colSort;
    },
  },
  computed: {
    agingTotals() {
  const sum = key => this.filteredInvoices.reduce((t, r) => t + (Number(r[key]) || 0), 0);
  return {
    bucket1: sum("bucket1"),
    bucket2: sum("bucket2"),
    bucket3: sum("bucket3"),
    bucket4: sum("bucket4"),
    total: sum("total"),
  };
},
    activeNav() {
      return this.$store.state.activePage;
    },

    showButton() {
      if (this.searchValue.trim().length > 0 || this.acFilter || this.searchStarted) {
        // console.log('true')
        return true;
      } else {
        // console.log('false')
        return false;
      }
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    filteredInvoices: function () {
      //set the current page to 0
      this.currPage = 1;
      //if the search box is filled in
      if (this.search.trim() !== "") {
        return this.invoices.filter((e) => {
          //filter the subject line by what is filled in the search box
          return (
            e.OrderNumber.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else if (this.selectedCat !== "Show All") {
        this.search = "";
        //console.log(this.selectedCat);
        return this.invoices.filter((f) => {
          return f.Type == this.selectedCat;
        });
      } else {
        //return this.invoices;
        if(this.employee){
          return this.invoices.filter((f) => {
            return f.total != 0;
          });
        } else {
          return this.invoices;
        }

        
        /*
        return this.invoices.filter((f) => {
          return f.total != 0;
        });
        */
      }
    },

    employee() {
      return this.$store.getters.isSpacesaverEmployee;
    },

    foundNoRGA: function () {
      if (this.search.length > 1 && this.filteredInvoices.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },

    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },

    totalPage: function () {
      return Math.ceil(this.invoices.length / this.countOfPage);
    },
    listingRestore: function () {
      if (
        !this.searchValue &&
        !this.loading &&
        !this.searching &&
        this.storedListings.length >= this.invoices
      ) {
        //console.log("fired off");
        this.invoices = this.storedListings;
      }
      return;
    },
    searchEndpointCompute: function () {
      //has order number, no start, no end, no ac
      if (this.searchValue && !this.acFilter) {
        return `${this.ordermanageapi}/cashmanagement?search=${this.searchValue.trim()}`;
      } else if (
        //has order number, and start, no end, no ac
        //!this.searchValue &&
        this.acFilter
      ) {
        return `${this.ordermanageapi}/cashmanagement/${this.acFilter}`;
      } else {
        return `${this.ordermanageapi}/cashmanagement`;
      }
    },
    clearSearchValue: function () {
      if (this.acFilter != null) {
        this.searchValue = "";
      }
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },

  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all and (min-width: 992px) {
  .flex-box-wrap {
    height: 200px;
    padding: 150px 0 125px 0;
    margin: 0;
  }
}

@media all and (max-width: 991px) {
  .flex-box-wrap {
    height: 100px;
    padding: 75px 0 50px 0;
    margin: 0;
    justify-content: center;
    align-items: center;
  }
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.invoice {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.invoice-bottom {
  align-items: flex-end;
}
.invoice-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: scroll;
}

.listing {
  background-color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
  padding: 23px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.search-btns .clear {
  margin-right: 0;
  margin-left: auto;
  padding: 23px 15px;
}
.search-btns .search {
  /*margin-left: auto;*/
  margin-right: 0;
  margin-left: auto;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
.right-side {
  text-align: right;
  flex: 1;
}
@media all and (max-width: 991px) {
  table {
    width: 900px !important;
    overflow: scroll;
  }
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}
.pixelsbggrid {
  background-color: #475059;
  background-size: cover;
  background-position: center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200' preserveAspectRatio='xMidYMid slice'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%2356626d' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2337778a'/%3E%3Cstop offset='1' stop-color='%2337778a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%232b5c60'/%3E%3Cstop offset='1' stop-color='%232b5c60' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23667787'/%3E%3Cstop offset='1' stop-color='%23667787' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='base' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='.5' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%231a8182'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='%23475059' width='1950' height='1200'/%3E%3Crect fill='url(%23base)' width='1950' height='1200'/%3E%3Cline x1='0' y1='0' x2='0' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='50' y1='0' x2='50' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='100' y1='0' x2='100' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='150' y1='0' x2='150' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='200' y1='0' x2='200' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='250' y1='0' x2='250' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='300' y1='0' x2='300' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='350' y1='0' x2='350' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='400' y1='0' x2='400' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='450' y1='0' x2='450' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='500' y1='0' x2='500' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='550' y1='0' x2='550' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='600' y1='0' x2='600' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='650' y1='0' x2='650' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='700' y1='0' x2='700' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='750' y1='0' x2='750' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='800' y1='0' x2='800' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='850' y1='0' x2='850' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='900' y1='0' x2='900' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='950' y1='0' x2='950' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1000' y1='0' x2='1000' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1050' y1='0' x2='1050' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1100' y1='0' x2='1100' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1150' y1='0' x2='1150' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1200' y1='0' x2='1200' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1250' y1='0' x2='1250' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1300' y1='0' x2='1300' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1350' y1='0' x2='1350' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1400' y1='0' x2='1400' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1450' y1='0' x2='1450' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1500' y1='0' x2='1500' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1550' y1='0' x2='1550' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1600' y1='0' x2='1600' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1650' y1='0' x2='1650' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1700' y1='0' x2='1700' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1750' y1='0' x2='1750' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1800' y1='0' x2='1800' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1850' y1='0' x2='1850' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1900' y1='0' x2='1900' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='0' x2='1950' y2='0' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='50' x2='1950' y2='50' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='100' x2='1950' y2='100' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='150' x2='1950' y2='150' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='1950' y2='200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='1950' y2='250' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='300' x2='1950' y2='300' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='350' x2='1950' y2='350' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='400' x2='1950' y2='400' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='450' x2='1950' y2='450' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='500' x2='1950' y2='500' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='550' x2='1950' y2='550' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='600' x2='1950' y2='600' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='650' x2='1950' y2='650' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='700' x2='1950' y2='700' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='750' x2='1950' y2='750' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='800' x2='1950' y2='800' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='850' x2='1950' y2='850' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='900' x2='1950' y2='900' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='950' x2='1950' y2='950' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1000' x2='1950' y2='1000' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='1050' x2='1950' y2='1050' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1100' x2='1950' y2='1100' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1150' x2='1950' y2='1150' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cg fill-opacity='0.45'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
}
/* ---------- Table typography ---------- */
.listing table { font-size: 14px; color: #2f3640; font-variant-numeric: tabular-nums; }

.table-striped th {
  background: #4d5967;
  color: #fff;
  font-size: 12px;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 10px;
  white-space: nowrap;
  vertical-align: middle;
}
.th-inner { display: flex; align-items: center; justify-content: space-between; gap: 6px; }
.table-striped th.num .th-inner { justify-content: flex-end; }

.table-striped td {
  padding: 10px;
  line-height: 1.35;
  font-weight: 400 !important;
  vertical-align: middle;
}

/* Column roles */
.table-striped td.ac a { color: #00797d; font-weight: 400; text-decoration: none; }
.table-striped td.ac a:hover { text-decoration: underline; }
.table-striped td.ac .acid { color: #8a9099; font-weight: 400; margin-left: 4px; }
.table-striped td.num { text-align: right; white-space: nowrap; }
.table-striped td.num.zero { color: #b8bdc3; }
.table-striped td.num.oldest:not(.zero) { color: #1f2933; font-weight: 400 !important; }
.table-striped td.num.total { color: #1f2933; font-weight: 400 !important; }

/* Totals row */
.table-striped tfoot td {
  background: #f1f3f5;
  border-top: 2px solid #4d5967 !important;
  font-weight: 400 !important;
  color: #1f2933;
}

/* Sort icons: quieter until active */
.carrot-icon { font-size: 16px; opacity: 0.45; vertical-align: middle; }
.carrot-icon-active { opacity: 1; }

.table-striped tbody tr:nth-of-type(odd) {
   background-color: rgb(241 246 249 / 60%) !important
}
</style>
